var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.795 1.54671L9.28025 1.54437C10.6523 1.54437 11.4713 2.38554 11.4713 3.79429V9.15862C11.4713 10.5575 10.6593 11.3986 9.30125 11.4068L4.816 11.4085C3.44458 11.4085 2.625 10.5674 2.625 9.15862V3.79429C2.625 2.39487 3.437 1.55487 4.795 1.54671ZM1.75 9.15862C1.75 11.0276 2.98258 12.2835 4.81658 12.2835L9.30417 12.2818C11.1522 12.2701 12.3463 11.044 12.3463 9.15862V3.79429C12.3463 1.92529 11.1143 0.669373 9.28025 0.669373H9.27967L4.79208 0.671706C2.94408 0.682789 1.75 1.90837 1.75 3.79429V9.15862ZM6.56297 4.52544H4.95588C4.71438 4.52544 4.51838 4.32944 4.51838 4.08794C4.51838 3.84644 4.71438 3.65044 4.95588 3.65044H6.56297C6.80447 3.65044 7.00047 3.84644 7.00047 4.08794C7.00047 4.32944 6.80447 4.52544 6.56297 4.52544ZM4.95606 6.96191H9.16773C9.40922 6.96191 9.60523 6.76591 9.60523 6.52441C9.60523 6.28291 9.40922 6.08691 9.16773 6.08691H4.95606C4.71456 6.08691 4.51856 6.28291 4.51856 6.52441C4.51856 6.76591 4.71456 6.96191 4.95606 6.96191ZM4.95606 9.40403H9.16773C9.40922 9.40403 9.60523 9.20803 9.60523 8.96653C9.60523 8.72503 9.40922 8.52903 9.16773 8.52903H4.95606C4.71456 8.52903 4.51856 8.72503 4.51856 8.96653C4.51856 9.20803 4.71456 9.40403 4.95606 9.40403Z",
    fill: "#082A51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApplication);
export default __webpack_public_path__ + "static/media/icon-application.d29074974a346e63f3bcb91a1aad776d.svg";
export { ForwardRef as ReactComponent };